import { useAuthenticationStore } from "@/stores/authentication";
import { useSchoolStore } from "@/stores/school";

export default function authHeader(postData) {
  const authenticationStore = useAuthenticationStore();
  const schoolStore = useSchoolStore();

  const jwt = authenticationStore.getToken();

  if (jwt?.access_token) {
    return {
      ...(postData instanceof FormData
        ? {}
        : {
            "content-type": "application/json"
          }),
      Authorization: "Bearer " + jwt.access_token,
      ...(authenticationStore.jwtData.authentication_type=='district'
        ? {
            "x-school-id": schoolStore.school_id || authenticationStore.jwtData.school_id
          }
        : {})
    };
  } else {
    return {};
  }
}
